import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ISMessengerComponent } from './is-messenger.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CdkMenuModule } from '@angular/cdk/menu';
import { MatChipsModule } from '@angular/material/chips';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared.module';

@NgModule({
    declarations: [ISMessengerComponent],
    imports: [
        CommonModule,
        MatTooltipModule,
        CdkMenuModule,
        MatChipsModule,
        FormsModule,
        SharedModule
    ],
    exports: [ISMessengerComponent],
    providers: [],
})
export class ISMessengerModule{}